module.exports = __webpack_public_path__ + "assets/7956161b162c5c3c023e505020775793.png";